const sitecoreScreens = [
  {
    id: "sitecore-home-insurance-desktop",
    kind: "desktop",
    slot: "desktop",
    src: "/images/cooperators/case-studies/sitecore/home-insurance-desktop.webp",
    alt: "Co-operators home insurance template on desktop with global navigation, modular content, and calls to action",
    caption: "Desktop template combining navigation, reusable content modules, and conversion paths",
    frame: {
      x: 3,
      y: 3,
      width: 84,
      height: 82,
      rotation: 0,
      zIndex: 1,
      cropX: 50,
      cropY: 5,
    },
  },
  {
    id: "sitecore-home-insurance-tablet",
    kind: "tablet",
    slot: "tertiary",
    src: "/images/cooperators/case-studies/sitecore/home-insurance-tablet.webp",
    alt: "Co-operators home insurance template adapted to a tablet layout",
    caption: "Tablet layout reflowing modules while preserving hierarchy and task access",
    frame: {
      x: 34,
      y: 30,
      width: 52,
      height: 68,
      rotation: 0,
      zIndex: 3,
      cropX: 50,
      cropY: 4,
    },
  },
  {
    id: "sitecore-home-insurance-mobile",
    kind: "phone",
    slot: "primary",
    src: "/images/cooperators/case-studies/sitecore/home-insurance-mobile.webp",
    alt: "Co-operators home insurance template adapted to a mobile layout",
    caption: "Mobile layout stacking the same authored modules into a focused reading path",
    frame: {
      x: 73,
      y: 20,
      width: 24,
      height: 76,
      rotation: 3,
      zIndex: 4,
      cropX: 50,
      cropY: 3,
    },
  },
];

export const sitecoreResponsiveGallery = sitecoreScreens.map((screen) => ({
  id: `${screen.id}-gallery`,
  src: screen.src,
  alt: screen.alt,
  caption: screen.caption,
}));

export default sitecoreScreens;
